var map = {
	"./iq_test_variant_1.json": [
		25608,
		5608
	],
	"./iq_test_variant_2.json": [
		16122,
		6122
	],
	"./iq_test_variant_3.json": [
		30329,
		329
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1968;
module.exports = webpackAsyncContext;